module.exports = __webpack_public_path__ + "static/BRCF-logo-c206560af87bea8d38a3bf040e4df622.png";